<app-table [data]="toolsGrouped"
           [config]="tableConfig"
           [treeMode]="true"
           [rowExpand]="true"
           [isLoading]="isLoading"
           [showFilters]="showFilters"
           [isFilterExpanded]="showFilters"
           [showGroupFilters]="showFilters"
           [groupFilters]="groupFilters"
           [showGroupers]="showGroupers"
           [groupableColumns]="groupableColumns"
           [directlyGrouped]="true"
           [displayToggleFilters]="false"
           [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
           [hasTitle]="hasTitle"
           [isMaterial]="isMaterial"
           [allExpanded]="allExpanded"
           isFilterExpanded="true"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (filterGroupChange)="onFilterGroupChange($event)"
           (groupChange)="onGroupChange($event)"
           (pageChange)="onPageChange($event)">
    <app-table-column header="{{'admin.tools.table.columns.toolName' | translate}}"
                      filterPlaceholder="{{'admin.tools.table.filters.toolName' | translate}}"
                      sortable="true"
                      filter="true"
                      [showTree]="true"
                      field="name">
        <ng-template #body
                     let-record="record">
            <div class="tool-select">
                <input type="checkbox"
                       (click)="onClickTool($event, record)"
                       *ngIf="hasCheckbox(record)"
                       [checked]="isChecked(record)"
                       [disabled]="isSelectionDisabled(record)"/>
                <span>{{ record.name }}</span>
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tools.table.columns.toolUid' | translate}}"
                      filterPlaceholder="{{'admin.tools.table.filters.toolUid' | translate}}"
                      sortable="true"
                      filter="true"
                      field="toolUid">
        <ng-template #body
                     let-record="record">
            <div [class.tool-set]="isToolSet(record)">
                {{ isToolSet(record) ? 'SET' : record.toolUid }}
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tools.table.columns.toolStatus' | translate}}"
                      sortable="true"
                      field="status">
        <ng-template #body
                     let-record="record">
            <div class="status-row"
                 [class.tool-set]="isToolSet(record)">
                <app-tooltip *ngIf="record?.stance" type="info"
                             [record]="isToolSet(record) ? 'SET' : record.stance || 'N/A'"></app-tooltip>
                {{ isToolSet(record) ? 'SET' : record.status }}
            </div>
        </ng-template>
    </app-table-column>
</app-table>
